import { ClaimItemDeleteUseCase } from '../../../application';

export default class ClaimItemDeleteService {
    constructor() {}

    async execute(event) {
        const request = await ClaimItemDeleteUseCase(event);

        return request;
    }
}
